<template>
  <a-card :bordered="false" >
    <div>
      <a-table
        :data-source="table.data"
        :scroll="{ y: 'calc(100vh - 410px)' }"
        row-key="id"
        style="width: 100%">
        <a-table-column
          data-index="name"
          title="name"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="country"
          title="country"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="city"
          title="city"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="stage"
          title="stage"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="mailingAddressLine1"
          title="mailingAddressLine1"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="mailingAddressLine2"
          title="mailingAddressLine2"
          width="80">
        </a-table-column>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import {
  _queryRingSizers,
} from '@/api/websiteRingSizerApi';

async function getList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryRingSizers({
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.pagination.total = result.totalElements;
  this.table.loading = false;
}

export default {
  name: 'WebsiteRingSizerList',
  components: {
    // WebsiteStoryEdit
  },
  data() {
    return {
      searchForm: {
        data: {
          title: '',
          content: '',
          image: '',
        },
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getList,
  },
  created() {
    this.getList();
  },
};
</script>

<style scoped>

</style>
